import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d8sdul5cg4qspo1262i0';

export default function Footer() {
  const catCol1 = categories.slice(0, 7);
  const catCol2 = categories.slice(7);

  return (
    <footer className="bg-secondary-50 pt-16 md:pt-20 pb-8 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Brand + Subscribe */}
          <div className="lg:w-[38%]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              OOPBuy /
            </h2>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Spreadsheets
            </h2>
            <p className="text-sm text-foreground-500 mt-4 max-w-sm leading-relaxed">
              Your trusted hub for ecommerce order tracking, spreadsheet automation guides, and product discovery. Connecting sellers with the tools they need to scale.
            </p>

            {/* Newsletter */}
            <div className="mt-10">
              <p className="text-xs font-semibold text-foreground-600 uppercase tracking-wider mb-3">
                Subscribe
              </p>
              <form
                data-readdy-form
                action={FORM_SUBMIT_URL}
                method="POST"
                encType="application/x-www-form-urlencoded"
                className="flex flex-col sm:flex-row gap-2"
                onSubmit={(e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const email = formData.get('email') as string;
                  if (!email || !email.includes('@')) {
                    alert('Please enter a valid email address.');
                    return;
                  }
                  fetch(FORM_SUBMIT_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ email }).toString(),
                  })
                    .then(() => {
                      alert('Thanks for subscribing! Check your inbox soon.');
                      form.reset();
                    })
                    .catch(() => {
                      alert('Something went wrong. Please try again later.');
                    });
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  required
                  className="flex-1 bg-transparent border-0 border-b border-foreground-300 px-1 py-2 text-sm text-foreground-800 placeholder:text-foreground-300 outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="px-5 py-2 text-sm font-semibold text-foreground-700 border border-foreground-300 rounded-md hover:bg-foreground-100/50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Join Newsletter
                </button>
              </form>
            </div>
          </div>

          {/* Right: Links */}
          <div className="lg:w-[62%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {/* Categories Col 1 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {catCol1.map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories Col 2 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4 opacity-0">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {catCol2.map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* SEO + Legal */}
            <div className="col-span-2 sm:col-span-1 space-y-8">
              {/* SEO Links */}
              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Resources
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <Link
                      to="/oopbuy-spreadsheet-guide"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                    >
                      Complete Guide
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                    >
                      Blog
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://kaspreadsheet.com/"
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors"
                    >
                      Official Store
                    </a>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Legal
                </h4>
                <ul className="space-y-2.5">
                  <li>
                    <a href="#" className="text-sm text-foreground-400 hover:text-foreground-700 transition-colors">
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-foreground-400 hover:text-foreground-700 transition-colors">
                      Terms of Service
                    </a>
                  </li>
                  <li>
                    <a href="#" className="text-sm text-foreground-400 hover:text-foreground-700 transition-colors">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-14 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheets. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            External links open in new tabs. We may earn commissions on qualifying purchases.
          </p>
        </div>
      </div>
    </footer>
  );
}